const React = require('react');
const { Image, Button } = require('stremio/components');
const { useTranslation } = require('react-i18next');
const { useServices } = require('stremio/services');
const styles = require('./styles');
const { useToast } = require('stremio/common');
const { useFredflixData } = require('stremio/common/FredflixContext');
const { RunFredflixFlow } = require('stremio/services/Fredflix');

// eslint-disable-next-line react/prop-types
const InactiveSubscription = ({ email, subscriptionEnd }) => {
    const { core } = useServices();
    const { t } = useTranslation();
    const toast = useToast();
    const { data: fredflixData } = useFredflixData();

    const logoutButtonOnClick = React.useCallback(() => {
        core.transport.dispatch({
            action: 'Ctx',
            args: {
                action: 'Logout'
            }
        });
    }, []);

    const useBalanceButtonOnClick = async () => {
        if (fredflixData.OnDemandBalance === null || fredflixData.OnDemandBalance <= 0) {
            toast.show({
                type: 'error',
                title: 'On Demand Balance insufficient',
                timeout: 4000
            });
            return;
        }

        let currentDate = new Date();
        const currentDateFormatted = currentDate.toISOString().split('T')[0];

        await RunFredflixFlow(
            email,
            'OnDemandUse',
            {
                'Date': currentDateFormatted,
                'PrevBalance': fredflixData.OnDemandBalance,
                'NewBalance': fredflixData.OnDemandBalance - 1,
            }
        );

        toast.show({
            type: 'success',
            title: 'On Demand Balance used! Thank you!',
            timeout: 3000
        });
        setTimeout(function () { location.reload(); }, 3000);
    };

    return (
        <div className={styles['intro-container']}>
            <div className={styles['background-container']} />
            <div className={styles['heading-container']}>
                <div className={styles['logo-container']}>
                    <Image className={styles['logo']} src={require('/images/logo.png')} alt={' '} />
                </div>
                <div className={styles['title-container']}>
                    Freedom to Stream
                </div>
                <div className={styles['slogan-container']}>
                    All the Video Content You Enjoy in One Place
                </div>
            </div>
            {fredflixData.Type === 'Subscription' && (
                <div className={styles['heading-container']}>
                    <div className={styles['slogan-container']}>
                        Oops! It seems that you don&apos;t have an active subscription in Fredflix.
                    </div>
                    <div className={styles['slogan-container']}>
                        ({email}) subscription ends at ({subscriptionEnd})
                    </div>
                    <div className={styles['logout-container']}>
                        <Button className={styles['logout-button-container']} title="Reload" href={null} onClick={() => location.reload()}>
                            <div className={styles['logout-label']}>Reload</div>
                        </Button>
                    </div>
                    <div className={styles['logout-container']}>
                        <Button className={styles['logout-button-container']} title={t('LOG_OUT')} href={null} onClick={logoutButtonOnClick}>
                            <div className={styles['logout-label']}>{t('LOG_OUT')}</div>
                        </Button>
                    </div>
                    <div className={styles['hint-container']}>
                        Note: Do you know that you can also pay subscription per day? Contact to apply
                    </div>
                </div>
            )}
            {fredflixData.Type === 'OnDemand' && (
                <div className={styles['heading-container']}>
                    <div className={styles['slogan-container']}>
                        Oops! It seems that your &rdquo;on demand subscription&rdquo; has ended.
                    </div>
                    <div className={styles['slogan-container']}>
                        ({email}) on demand balance: {fredflixData.OnDemandBalance || 0}
                    </div>
                    <div className={styles['use-balance-container']}>
                        <Button className={styles['use-balance-button']} title="Use your balance" href={null} onClick={useBalanceButtonOnClick}>
                            Use your balance
                        </Button>
                    </div>
                    <div className={styles['logout-container']}>
                        <Button className={styles['logout-button-container']} title="Reload" href={null} onClick={() => location.reload()}>
                            <div className={styles['logout-label']}>Reload</div>
                        </Button>
                    </div>
                    <div className={styles['logout-container']}>
                        <Button className={styles['logout-button-container']} title={t('LOG_OUT')} href={null} onClick={logoutButtonOnClick}>
                            <div className={styles['logout-label']}>{t('LOG_OUT')}</div>
                        </Button>
                    </div>
                    <div className={styles['hint-container']}>
                        Balance last used at: {fredflixData.OnDemandDate || 'never'}
                    </div>
                </div>
            )}
        </div>
    );
};

module.exports = InactiveSubscription;
